
import { defineComponent, ref, computed, watch } from "vue";
import { QuillEditor } from "@vueup/vue-quill";

const __default__ = defineComponent({
  name: "RichTextEditor",
  components: {
    QuillEditor,
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Write something...",
    },
    height: {
      type: String,
      default: "300px",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const quillEditor = ref();
    const content = ref(props.modelValue);

    const editorOptions = computed(() => ({
      theme: "snow",
      placeholder: props.placeholder,
      readOnly: props.readonly,
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["link", "image"],
          ["clean"],
        ],
      },
    }));

    // Watch for external changes to modelValue
    watch(
      () => props.modelValue,
      (newValue) => {
        if (newValue !== content.value) {
          content.value = newValue;
        }
      }
    );

    const onContentChange = (value: string) => {
      emit("update:modelValue", value);
    };

    // Expose methods for parent components
    const getQuill = () => quillEditor.value?.getQuill();
    const setContent = (html: string) => {
      content.value = html;
    };
    const getContent = () => content.value;
    const focus = () => quillEditor.value?.focus();

    return {
      quillEditor,
      content,
      editorOptions,
      onContentChange,
      getQuill,
      setContent,
      getContent,
      focus,
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "v47f89e12": (_ctx.height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__